import i18n from '@/helper/i18n';

export default function formatPermanentDebtStatus(value) {
  return i18n.te(`permanentDebts.statusOptions.${value}`)
    ? i18n.t(`permanentDebts.statusOptions.${value}`)
    : value;
}
